export function safePhotoFilename(value, fallback = "foto.jpg") {
  const original = String(value || "");
  if (original.startsWith("image_sediment:")) return fallback;
  const raw = original.split(/[\\/]/).pop() || fallback;
  const cleaned = raw.replace(/[<>:"/\\|?*]/g, "_").trim();
  if (!cleaned) return fallback;
  return cleaned;
}

export function photoMimeFromFilename(filename) {
  const extension = String(filename || "").split(".").pop()?.toLowerCase();
  return {
    png: "image/png",
    webp: "image/webp",
    heic: "image/heic",
    heif: "image/heif",
  }[extension] || "image/jpeg";
}

export function photoArchivePresentation(state) {
  if (!state) return { label: "Archiefstatus onbekend", className: "is-pending", title: "" };
  if (state.status === "archived") {
    return {
      label: "In Dropbox",
      className: "is-archived",
      title: state.dropboxPath || "Gearchiveerd in Dropbox",
    };
  }
  if (state.status === "archive_failed") {
    return {
      label: "Archivering mislukt",
      className: "is-failed",
      title: state.lastArchiveError || "Dropbox-archivering is mislukt",
    };
  }
  return {
    label: state.status === "archiving" ? "Wordt gearchiveerd" : "Wacht op archivering",
    className: "is-pending",
    title: "De foto staat veilig in het rapport en wordt naar Dropbox verwerkt.",
  };
}

export function cyclePhotoIndex(currentIndex, photoCount, delta) {
  if (!Number.isInteger(currentIndex) || !Number.isInteger(photoCount) || photoCount <= 0) {
    return null;
  }
  const normalizedDelta = Number.isFinite(delta) ? Math.trunc(delta) : 0;
  return (currentIndex + normalizedDelta % photoCount + photoCount) % photoCount;
}

export function buildPhotoMoveOperation(asset, targetWorkAssignmentId, revision) {
  const reportAssetId = String(asset?.report_asset_id || "").trim();
  const storagePath = String(asset?.storage_path || "").trim();
  const filename = String(asset?.filename || "").trim();
  const targetId = String(targetWorkAssignmentId || "").trim();
  if (!reportAssetId || !storagePath || !filename || !targetId) return null;

  const operationId = [
    "pwa-move-photo",
    reportAssetId,
    targetId,
    String(revision),
  ].join(":").slice(0, 200);
  const caption = String(asset?.caption || "").trim();
  const operation = {
    type: "set_asset",
    operation_id: operationId,
    report_asset_id: reportAssetId,
    work_assignment_id: targetId,
    storage_path: storagePath,
    filename,
    display_order: Number.isInteger(asset?.display_order) ? asset.display_order : 0,
    ...(caption ? { caption } : {}),
  };

  return { operationId, operation };
}
